import React, { useEffect } from "react";
import "./KaramalePrivacy.css"; // Optional: add your styles here
import Header3 from "./components/Header3";
import Header2 from "./components/Header2";
import Header5 from "./components/Header5";
import Header from "./components/Header";

function KaramalePrivacy() {
  useEffect(() => {
    document.title = "Karamale Privacy Policy";
  }, []);
  return (
    <>
      {localStorage.getItem("customername") !== null ? (
        <Header2 />
      ) : localStorage.getItem("businessname") !== null ? (
        <Header3 />
      ) : localStorage.getItem("partner") !== null ? (
        <Header5 />
      ) : (
        <Header />
      )}
      <div className="container">
        <div className="row justify-content-center just-container-insid">
          <div className="col-lg-8 pl-0 pr-0">
            <div className=" BoxDashboardContainer mt-5 mb-4 mrgin-search">
              <h3>Karamale Privacy Policy</h3>

              <section>
                <h2>1. Introduction</h2>
                <p>
                  Karamale is committed to protecting your personal information
                  and ensuring transparency in how we collect, use, and store
                  data. This policy explains what we collect and how we use it.
                </p>
              </section>

              <section>
                <h2>2. Information We Collect</h2>
                <ul>
                  <li>
                    <strong>Personal Details:</strong> Name, email, phone
                    number, ID (if required).
                  </li>
                  <li>
                    <strong>Account Activity:</strong> Purchases, attendance,
                    refunds, scans.
                  </li>
                  <li>
                    <strong>Device Info:</strong> IP, browser, device, session
                    logs.
                  </li>
                  <li>
                    <strong>Payment Data:</strong> Transaction info (via
                    gateway), excluding full card numbers.
                  </li>
                  <li>
                    <strong>Location Data:</strong> Based on IP, used for
                    discovery and fraud prevention.
                  </li>
                </ul>
              </section>

              <section>
                <h2>3. How We Use Your Information</h2>
                <ul>
                  <li>
                    Deliver tickets to your Karamale account and enable entry
                    via QR code.
                  </li>
                  <li>Process secure payments and refunds.</li>
                  <li>
                    Send notifications about events, changes, or cancellations.
                  </li>
                  <li>Prevent fraud or duplicate refund misuse.</li>
                  <li>Improve platform experience and performance.</li>
                </ul>
              </section>

              <section>
                <h2>4. Data Security</h2>
                <ul>
                  <li>
                    Encrypted QR ticket validation and secure authentication.
                  </li>
                  <li>Audit logs for scans, refunds, and account activity.</li>
                  <li>Role-based admin access for event organisers.</li>
                </ul>
              </section>

              <section>
                <h2>5. Data Sharing</h2>
                <p>
                  We do <strong>not sell</strong> your personal data. We may
                  share limited data with:
                </p>
                <ul>
                  <li>Event organisers (ticket type, scan status).</li>
                  <li>
                    Payment processors (e.g. PayFast) for transaction handling.
                  </li>
                  <li>Law enforcement or regulators if legally required.</li>
                </ul>
              </section>

              <section>
                <h2>6. Your Rights</h2>
                <ul>
                  <li>Access, correct, or delete your data.</li>
                  <li>Opt out of marketing communications.</li>
                  <li>Request a record of your ticketing history.</li>
                </ul>
                <p>
                  Use your account dashboard or contact support to make a
                  request.
                </p>
              </section>

              <section>
                <h2>7. Data Retention</h2>
                <p>
                  Ticketing and transaction data is retained for up to{" "}
                  <strong>5 years</strong>. QR scans and refund history may be
                  stored longer for fraud prevention.
                </p>
              </section>

              <section>
                <h2>8. POPIA Compliance</h2>
                <p>
                  Karamale complies with the Protection of Personal Information
                  Act (POPIA). We handle your data lawfully, transparently, and
                  for legitimate purposes only.
                </p>
              </section>

              <section>
                <h2>9. Contact Us</h2>
                <ul>
                  <li>
                    Email:{" "}
                    <a href="mailto:support@karamale.com">
                      support@karamale.com
                    </a>
                  </li>
                  <li>
                    Dashboard: Use the "Privacy Request" option under Account
                    Settings
                  </li>
                </ul>
              </section>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default KaramalePrivacy;
